import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import Debounce from '../../js/lib/debounce';
import currentLang from '../../js/lib/currentLang';

const roster = document.getElementById('MemberRoster');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

if(roster)
{
	const initUrl = envVar({
		backendPath: '/Company/FullList',
		staticPath: 'js/data/searchInit.json'
	});

	var LoadingComponent = {
		template: '#loading-template',
	};

	var CompanyDetailComponent = {
		template: '#detail-template',
		props: ['companydetail'],
		data: function() {
			return {
				companyData: '',
			}
		},
		mounted: function() {
			const self = this;

			self.companyData = self.companydetail;

		},
	};

	request().get(initUrl).then(function(response) {
		const rosterVue = new Vue({
			// countries Element ~> this.$el
			el: '#MemberRoster',
			// Define Schema ~> set to null/0
			data: {
				companies: '',
				selected: '',
				input: '',
				showCompany: '',
				chosenCountry: '',
				chosenCountryFlag: '',
				chosenCountryText: '',
			},
			watch: {
				// whenever input changes, this function will run
				input: function(newInput) {
					this.getPrompt();
				}
			},
			// When Component is Mounted, run Methods
			mounted: function() {
				const self = this;
				self.companies = response;
				self.selected = response;

				// infinite loop; my own watcher since watching hidden variables doesn't work
				setTimeout(() => { self.checkCountry(); }, 500);
			},
			components: {
				'detail-component': CompanyDetailComponent,
				'loading-component': LoadingComponent,
			},
			// Methods
			methods: {
				checkCountry: function() {
					const self = this;
					const hiddenVar = document.getElementById('ChosenCountry');
					if(hiddenVar.value != self.chosenCountry)
					{
						self.chosenCountry = hiddenVar.value;
						const flag = document.getElementById('ChosenCountryFlag');
						self.chosenCountryFlag = flag.value;
						const text = document.getElementById('ChosenCountryText');
						self.chosenCountryText = text.value;
					}

					setTimeout(() => { self.checkCountry(); }, 500);
				},
				removeCountry: function() {
					const self = this;
					self.chosenCountry = '';
					self.chosenCountryFlag = '';
					self.chosenCountryText = '';

					const hiddenVar = document.getElementById('ChosenCountry');
					hiddenVar.value = '';

					self.checkCountry();
				},
				getPrompt: Debounce(function() {
					var self = this;

					if (self.input.length < 2) 	
						self.selected = self.companies;
					else
					{
						self.selected = [];

						var findMatch = new RegExp(self.input,"gi");
						for (var x = 0; x < self.companies.length; x++) 
						{
							if(self.companies[x].companyName.match(findMatch))
								self.selected.push(self.companies[x]);
						}
					}
					// filter companies
	
				}, 500),
				flyoutCompany: function(id) {
					const self = this;

					// find in normal array
					for (var x = 0; x < self.companies.length; x++) 
					{
						if(self.companies[x].id == id)
						{
							var index = x;
							break;
						}
					}

					// find in selected, if necessary
					if(self.selected.length < index + 1 || self.selected[index].id != id) 
					{
						for (var x = 0; x < self.selected.length; x++) 
						{
							if(self.selected[x].id == id)
							{
								var selectedindex = x;
								break;
							}
						}
					}
					else
						var selectedindex = index;

					if(self.showCompany == self.companies[index].id)
						self.showCompany = '';
					else
					{
						self.showCompany = self.companies[index].id;
						self.companies[index].component = 'loading-component';
	
						if(!self.companies[index].isLoaded)
						{
							request().get('/Company/Info/' + self.companies[index].id).then(function(response) {
								self.companies.splice(index, 1, response);
								self.selected.splice(selectedindex, 1, response);
								self.selected[selectedindex].component = 'detail-component';

								// get client manager
								request().get('/MyLimraPage/ClientManager/' + response.clientManagerCrmid + '?companyName=' + response.companyName + '&lang=' + currentLang()).then(function(response) {
									self.companies[index].clientManagerHtml = response;
									self.selected[selectedindex].clientManagerHtml = response;
									self.companies[index].isLoaded = true;
								});
							});
						}
						else
							self.companies[index].component = 'detail-component';

					}
				},
			}
		});
	});
}



// WEBPACK FOOTER //
// ../components/memberroster/memberroster.js